<template>
  <div>
    <add-payment-type :is-active.sync="isAdding" @changed="paymentTypeAdded" />
    <data-table
      title="Payout Transactions"
      :url="url"
      :headers="headers"
      :fields="fields"
      ref="table"
      searchable
      :archive="true"
      :dateSort="true"
      :csv="true"
      csvFileName="cashouts.csv"
      :csvFields="csvFields"
      @date-range-updated="(url) => (this.url = url)"
      @update-archived="(status) => (this.showArchived = status)"
      @click:row="showDetails"
      @rowClicked="showDetails"
    >
      <template #action.icons>
        <div class="d-flex mr-3 justify-center items-center">
          <v-btn color="primary" @click="isAdding = true" class="mr-3">
            <v-icon color="light-blue lighten-4">
              mdi-plus-outline
            </v-icon>
            Make a withdraw
          </v-btn>

          <v-select
            label="Transaction Status"
            dense
            v-model="status"
            solo
            filled
            clearable
            :items="[
              { text: 'Pending', value: 'pending' },
              { text: 'Started', value: 'started' },
              { text: 'Error', value: 'error' },
              { text: 'Completed', value: 'completed' },
            ]"
          ></v-select>
        </div>
      </template>
      <template slot="item.status" slot-scope="{ item }">
        <v-icon color="success" v-if="item.status === 'completed'"> mdi-progress-check </v-icon>
        <v-icon color="grey" v-else-if="item.status === 'pending'"> mdi-progress-alert </v-icon>
        <v-icon color="primary" v-else-if="item.status === 'started'"> mdi-progress-clock </v-icon>
        <v-tooltip left v-else-if="item.status === 'error'">
          <template v-slot:activator="{ on, attrs }">
            <v-icon color="error" v-bind="attrs" v-on="on"> mdi-progress-close </v-icon>
          </template>
          <span>{{ item.failure_reason }}</span>
        </v-tooltip>
      </template>
    </data-table>
  </div>
</template>
<script>
import AddPaymentType from "./form";

export default {
  components: { AddPaymentType },

  data() {
    return {
      status: "",
      isAdding: false,
      url: "api/v1/cashout",
      showArchived: false,
      headers: {
        created_at: "Date (created at)",
        sender_full_name: "Sender full name",
        "source_user.full_name": "Recipient full name",
        "destination_user.full_name": "Distributor full name",
        amount_in_euros: "Amount (Euro)",
        amount: "Amount (local currency)",
        payment_method: "Payment method",
        "payout.type": "Payout method",
        status: " Cashout status",
        "payout.status": "Payout status",
      },
      fields: {
        created_at: {
          type: "date",
        },
        started_at: {
          type: "date",
        },
        amount_in_danacoin: {
          type: "currency",
        },
        amount: {
          format: (value, item) => {
            return `${item.amount_in_receiver_currency}`;
          },
        },
        amount_without_fee: {
          format: (value) => {
            return `€ ${this.asCurrency(value)}`;
          },
        },
      },
      csvFields: [
        {
          label: "Recipient User",
          value: "source_user.full_name",
          default: "",
        },
        {
          label: "Recipient Phone Number",
          value: "source_user.full_phone_number",
          default: "",
        },
        {
          label: "Distributor Name",
          value: "destination_user.full_name",
          default: "",
        },
        {
          label: "Amount (EUR)",
          value: "amount_without_fee",
          default: "",
        },
        {
          label: "Amount (Local Currency)",
          value: "local_amount_without_fee",
          default: "",
        },
        {
          label: "Country",
          value: "source_user.country",
          default: "",
        },
        {
          label: "Phone Number",
          value: "source_user.full_phone_number",
          default: "",
        },
        {
          label: "Status",
          value: "status",
          default: "",
        },
      ],
    };
  },
  watch: {
    url() {
      this.$nextTick(() => {
        this.$refs.table.fetchData();
      });
    },
    status(val) {
      let data = { name: "status", value: "" };
      if (val) {
        data = { name: "status", value: val };
      }
      const params = this.$refs.table.addParams(this.url, [data]);
      this.url = `/api/v1/cashout?${params}`;
    },
    showArchived: function (val) {
      const params = this.$refs.table.addParams(this.url, []);
      if (val) {
        this.url = `/api/v1/cashout/all?${params}`;
      } else {
        this.url = `/api/v1/cashout?${params}`;
      }
    },
  },
  methods: {
    showDetails({ id }) {
      this.$router.push({ name: "cashouts.show", params: { id } });
    },
    paymentTypeAdded({ message }) {
      this.isAdding = false;
      Notify.success(message);
      // refresh the table data
      this.$refs.table.fetchData();
    },
  },
};
</script>
